import React from 'react'
// import LogoImage from '../../../../assets/img/simplified-login/logo.png'
import useRegistrationBanners, {
  REGISTRATION_STEPS,
} from '../../../../services/hooks/useRegistrationBanners'
import {
  LayoutContainer,
  LeftPane,
  RightPane,
  // LogoContainer,
  // Logo,
  StyledFooter as Footer,
  RightFooter,
  MobileBanner,
  MobileFooterWrapper,
  AppVersion,
} from './Layout.style'
import { screenSizes } from '../../../../services/generateMediaQueries'

const Layout = ({
  showVersion,
  children,
  // noMobileLogo,
  registrationStep,
}) => {
  const {
    getBanners,
    getRegistrationStepBanner,
    loading,
  } = useRegistrationBanners({ registrationStep })

  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    getBanners()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (typeof window === 'undefined') return
    const checkMobile = () =>
      setIsMobile(window.innerWidth <= screenSizes.small)
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <LayoutContainer>
      <LeftPane
        bannerImage={
          (!loading || registrationStep === REGISTRATION_STEPS.LOGIN) &&
          getRegistrationStepBanner(registrationStep)
        }
      >
        {/* ST-5832 - remove logo
        <LogoContainer>
          <Logo src={LogoImage} />
        </LogoContainer> */}
        <Footer />
      </LeftPane>
      <RightPane>
        {showVersion && (
          <AppVersion>{process.env.REACT_APP_BUILD_NO}</AppVersion>
        )}
        <MobileBanner
          bannerImage={
            (!loading || registrationStep === REGISTRATION_STEPS.LOGIN) &&
            getRegistrationStepBanner(registrationStep)
          }
        >
          {/* ST-5832 remove zing logo */}
          {/* {noMobileLogo ? null : <Logo src={LogoImage} />} */}
        </MobileBanner>
        {children}
        {isMobile && (
          <RightFooter>
            <MobileFooterWrapper>
              <Footer />
            </MobileFooterWrapper>
          </RightFooter>
        )}
      </RightPane>
    </LayoutContainer>
  )
}

export default Layout
